/*
 * Copyright (c) Nexign, JSC, 2022.
 */
/**
 *
 *
 * @author Yakov Gushchin
 * @version 1.19.0
 * @since 1.19.0
 */

import { memo } from 'react';

import { useSelector } from 'react-redux';

import { MultiSelect } from '../../../../components/common';
import { EInputKind } from '../../../../components/common/Input/Input';
import { IMultiSelectItem } from '../../../../components/common/MultiSelect/components/MultiSelectItemList';
import LabelSelectList from '../../../../components/common/MultiSelect/components/SelectItemContainer/LabelSelectList';
import { IMultiSelectLabelProps } from '../../../../components/common/MultiSelect/MultiSelect';
import { IOptionItemProps } from '../../../../components/common/Select/Select';
import { makeSelectTranslationCommon } from '../../../internationalization/intSelectors';
import { useTableFilterApi } from '../../api';
import { useTableFilter } from './hooks/useTableFilter';
import { useTableLabels } from './hooks/useTableLabels';

interface ITableFilterLabels {
    name: string;
}

const TableFilterLabels = ({ name }: ITableFilterLabels) => {

    const translationCommon = useSelector(makeSelectTranslationCommon());

    const { options } = useTableLabels();

    const apiFilter = useTableFilterApi();

    const { filters, selectedFilter } = useTableFilter(name);

    const selectedValue: number[] = selectedFilter?.include ?? [];
    const selectedOptions = options?.filter(i => selectedValue.includes(i.value)) ?? [];

    const onSelect = (item: IOptionItemProps[]) => {
        const values = item?.map(i => i.value) ?? [];
        const fieldFilter = { [name]: values.length ? { include: values } : undefined };

        apiFilter.filter({ ...filters, ...fieldFilter });
    };

    return (
        <MultiSelect
            kind={EInputKind.normal}
            options={options}
            // @ts-ignore
            renderOptions={
                (props: IMultiSelectLabelProps & IMultiSelectItem) => <LabelSelectList {...props}/>
            }
            selectedOptions={selectedOptions}
            translation={translationCommon}
            onSelect={onSelect}
        />
    );
};

export default memo(TableFilterLabels);
